import React from "react"
import types from "prop-types"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import { departmentIdentifier } from "utils/taskHelpers"
import TaskDepartment from "../TaskDepartment"

const TaskDepartmentList = ({
  className = "",
  departments,
  removeDepartment,
  toggleNotify,
  toggleNotifyOnComplete,
  departmentLabelComponent,
  segmentsComponent,
  departmentDescriptor,
}) => {
  const { pluralName: departmentsName } = useCustomName(DEPARTMENT_KEY)

  const removeFromTask = (dept) => () => removeDepartment(departmentIdentifier(dept))

  return (
    <div className={className}>
      <div className="flex gap-2 w-full font-semibold text-sm items-end pr-16 mb-2">
        <span className="grow">{departmentsName}</span>
        <div className="hidden lg:block w-20 text-center">Notify on Assign</div>
        <div className="hidden lg:block w-20 text-center">Notify on Complete</div>
      </div>
      {
        departments.map((department) => (
          <TaskDepartment
            key={`task-department-${department.departmentId ?? department.questionUUID}`}
            className="mb-2 last:mb-0"
            departmentSelection={department}
            removeFromTask={removeFromTask(department)}
            toggleNotify={toggleNotify(department)}
            toggleNotifyOnComplete={toggleNotifyOnComplete(department)}
            labelComponent={departmentLabelComponent}
            segmentsComponent={segmentsComponent}
            departmentDescriptor={departmentDescriptor}
          />
        ))
      }
    </div>
  )
}

TaskDepartmentList.propTypes = {
  className: types.string,
  departments: types.arrayOf(types.object).isRequired,
  removeDepartment: types.func.isRequired,
  toggleNotify: types.func.isRequired,
  toggleNotifyOnComplete: types.func.isRequired,
  departmentLabelComponent: types.elementType.isRequired,
  segmentsComponent: types.elementType.isRequired,
  departmentDescriptor: types.string.isRequired,
}

export default TaskDepartmentList
